<template>
  <button class="functionBtn" @click="handleClick" :disabled="disabled || loading" :type="nativeType" :class="[classIn,{disable:disabled||loading}]">
    <Icon class="w1x h1x ani fWhite" :sizeBase="'s'" name="load" v-if="icon" />
    <span v-if="$slots.default">
      <slot></slot>
    </span>
    <Icon class="w1x h1x ani" :sizeBase="'s'" name="load" v-if="loading" />
  </button>
</template>
<script>
export default {
  name: 'functionButton',
  props: {
    nativeType: {
      type: String,
      default: 'button'
    },
    classIn: {
      type: String,
      default: 'sizeM'
    },
    icon: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
  },
  methods: {
    handleClick (evt) {
      this.$emit('click', evt)
    }
  }
}
</script>
<style lang="scss" scoped>
.ani {
  animation: load 0.5s linear infinite;
}
@keyframes load {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/FunctionButton.vue